<script setup lang="ts">
// TODO(F2-B): mount <ConfirmDialog /> inside AppShell.vue
// (App.vue принадлежит F0 и не правится отсюда; без ровно одного смонтированного
//  экземпляра `useConfirm().confirm()` вернёт промис, который никто не разрешит).
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { confirmState, resolveConfirm } from '@/composables/useConfirm'

/**
 * Диалог закрыли не кнопкой подтверждения — Esc, клик по оверлею, `AlertDialogCancel`.
 * Для вызывающего кода это отказ, и промис обязан разрешиться, иначе `await` повиснет.
 */
function onOpenUpdate(value: boolean): void {
  if (!value) resolveConfirm(false)
}
</script>

<template>
  <AlertDialog :open="confirmState.open" @update:open="onOpenUpdate">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{{ confirmState.title }}</AlertDialogTitle>
        <!--
          Описание рендерится всегда: reka-ui вешает на контент `aria-describedby`
          и ругается в консоль, если элемента нет. Без текста — прячем визуально,
          но не от скринридера.
        -->
        <AlertDialogDescription :class="confirmState.description ? undefined : 'sr-only'">
          {{ confirmState.description || 'Подтвердите действие.' }}
        </AlertDialogDescription>
      </AlertDialogHeader>

      <AlertDialogFooter>
        <!--
          Отмена — родной `AlertDialogCancel`: reka ставит на него фокус при открытии
          (наименее разрушительное действие), а закрытие приезжает сюда через `update:open`.
        -->
        <AlertDialogCancel>
          {{ confirmState.cancelText }}
        </AlertDialogCancel>

        <!--
          Подтверждение — обычная `Button`, а НЕ `AlertDialogAction`.
          `AlertDialogAction` закрывает диалог своим внутренним обработчиком, который
          отрабатывает РАНЬШЕ нашего `@click`: `update:open(false)` успевал разрешить
          промис как отказ, и «Подтвердить» возвращал `false`. Здесь состоянием
          управляем мы сами, поэтому порядок слушателей роли не играет.
        -->
        <Button
          :variant="confirmState.destructive ? 'destructive' : 'default'"
          @click="resolveConfirm(true)"
        >
          {{ confirmState.confirmText }}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
